/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AgentPayments as AgentApiContractAgentPayments } from '../../models/AgentApi/Contract/agent-payments';

export interface ApiAgentListAgentPaymentsGet$Params {

/**
 * Interface language
 */
  lang?: string;

/**
 * status filter: 0 – pending approval; 1 - approved; 2 - rejected; null - no filter (any)
 */
  status?: number;

/**
 * date with
 */
  start?: string;

/**
 * date to (inclusive)
 */
  end?: string;
}

export function apiAgentListAgentPaymentsGet(http: HttpClient, rootUrl: string, params?: ApiAgentListAgentPaymentsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AgentApiContractAgentPayments>>> {
  const rb = new RequestBuilder(rootUrl, apiAgentListAgentPaymentsGet.PATH, 'get');
  if (params) {
    rb.query('lang', params.lang, {});
    rb.query('status', params.status, {});
    rb.query('start', params.start, {});
    rb.query('end', params.end, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<AgentApiContractAgentPayments>>;
    })
  );
}

apiAgentListAgentPaymentsGet.PATH = '/api/Agent/ListAgentPayments';
